/* eslint-disable no-case-declarations */
/* eslint-disable react/jsx-wrap-multilines */
import React, { useReducer } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import s from './preferencePriorities.module.css';

// TODO: refactor to use the renderprops pattern -> https://reactjs.org/docs/render-props.html ?

const mockData = [
  [
    { title: '2nd item title', id: 'item-id-2' },

  ],
  [
    { title: '3rd item title', id: 'item-id-3' },
    { title: '1st item item title', id: 'item-id-1' },
  ],
  [
    { title: '4th item title', id: 'item-id-4' },
  ],
  [
    { title: '5th item title', id: 'item-id-5' },
  ]
];

const PriorityItem = ({ dispatch, levelBoxIndex, itemIndex, item, showArrowUp, showArrowDown, noOfLevels }) => {
  return (
    <div className='d-flex justify-content-between'>
      <span className={s.title}>{item.title}</span>
      <div className={s.arrowsCont}>
        {(showArrowDown) && <FontAwesomeIcon icon={['fas', 'chevron-down']} color='#404040' className={s.arrowDown} onClick={() => dispatch({ type: 'levelDown', payload: { itemIndex, levelBoxIndex, noOfLevels } })} />}
        {(showArrowUp) && <FontAwesomeIcon icon={['fas', 'chevron-up']} color='#404040' className={s.arrowUp} onClick={() => dispatch({ type: 'levelUp', payload: { itemIndex, levelBoxIndex, noOfLevels } })} />}
      </div>
    </div>
  );
};

const PriorityLevel = ({ index, children }) => {
  return (
    <div className={s.priorityLevel}>
      <div className='d-flex'>
        <div className={s.levelCountCont}>
          <h2 className={s.levelCount}>{index + 1}</h2>
        </div>
        {children}
      </div>
      <div className={s.separator} />
    </div>
  );
};

function moveItemToDifferentLevel(prevState, levelBoxIndex, itemIndex, offset) {
  const stateCopy = [...prevState];
  // get and remove property to be moved

  const extractedItem = (stateCopy[levelBoxIndex].splice(itemIndex, 1))[0];

  const newLevelBoxIndex = levelBoxIndex + offset;
  if (offset < 0) {
    stateCopy[newLevelBoxIndex].push(extractedItem);
  } else {
    stateCopy[newLevelBoxIndex].unshift(extractedItem);
  }

  // check if original is now empty
  if (stateCopy[levelBoxIndex].length === 0) {
    stateCopy.splice(levelBoxIndex, 1);
  }

  return stateCopy;

}
/**
 * We can have as many priority levels as entries.
 * If top priority contains more than 1 entry and
 *   we choose to levelUp, all other entries level
 *   down instead.
 * If top priority contains just 1 entry, it cannot
 *  level up and the up arrow sign is not shown.
 * Same goes for the last priority item in the last
 *  level box but reversed.
 */
function reducer(state, action) {
  const { itemIndex, levelBoxIndex, noOfLevels } = action.payload;
  switch (action.type) {
    case 'levelUp':
      if (levelBoxIndex !== 0) {
        return moveItemToDifferentLevel(state, levelBoxIndex, itemIndex, -1);
      }

      return moveItemToDifferentLevel([...[[], ...state]], levelBoxIndex + 1, itemIndex, -1);
    case 'levelDown':
      if ((levelBoxIndex + 1) !== noOfLevels) {
        return moveItemToDifferentLevel(state, levelBoxIndex, itemIndex, +1);
      }

      return moveItemToDifferentLevel([...[...state, []]], levelBoxIndex, itemIndex, +1);
    default:
      throw new Error();
  }
}

const PreferencePriorities = () => {
  // react's useReducer hook is like redux but for component state instead of global
  const [state, dispatch] = useReducer(reducer, mockData);
  // Todo: add useEffect that listens for state change and sends request with payload the new state

  const noOfLevels = state.length;
  return (
    <div className={s.cont}>
      {state.map(((levelBox, levelBoxIndex) => {
        const noOfChildren = levelBox.length;
        // only for 1st entry if it's the only one in level 1 (top priority)
        const showArrowUp = !(levelBoxIndex === 0 && noOfChildren === 1);
        // only for last entry if it's the only one in lowest priority
        const showArrowDown = !((levelBoxIndex + 1) === noOfLevels && noOfChildren === 1);

        return (
          <PriorityLevel {...{ index: levelBoxIndex }}>
            <div className={s.prItemDivCont}>
              {levelBox.map((item, itemIndex) => (
                <PriorityItem {...{ dispatch }} item={item} {...{ levelBoxIndex, itemIndex, showArrowUp, showArrowDown, noOfLevels }} />
              ))}
            </div>
          </PriorityLevel>);
      }))}
    </div>
  );

};

export default PreferencePriorities;
